import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { SuvoCoreClientLibModule } from '@suvo-bi-core';
import { RefreshTokenInterceptor } from './features/authentication/interceptors/refresh-token/refresh-token.interceptor';
import { SelectedOrganisationInterceptor } from './features/authentication/interceptors/selected-organisation/selected-organisation.interceptor';
import { SelectedTenantInterceptor } from './features/authentication/interceptors/selected-tenant/selected-tenant.interceptor';
import { TokenInterceptor } from './features/authentication/interceptors/token/token.interceptor';
import { UnverifiedEmailInterceptor } from './features/authentication/interceptors/unverified-email/unverified-email.interceptor';
import { AuthenticationModule } from './features/authentication/modules/authentication/authentication.module';
import { BranchService } from './features/branch/services/branch/branch.service';
import { OrganisationInvitationModule } from './features/invitations/organisations/modules/organisation-invitation/organisation-invitation.module';
import { MyAccountModule } from './features/my-account/modules/my-account.module';
import { OrganisationModule } from './features/organisation/modules/organisation/organisation.module';
import { CommonOrganisationService } from './features/organisation/services/common-organisation/common-organisation.service';
import { OrganisationService } from './features/organisation/services/organisation/organisation.service';
import { SubscriptionModule } from './features/subscription/modules/subscription.module';
import { VerifyModule } from './features/verify';
import { IdentityService } from './shared/services/identity/identity.service';
import { SuvoUsersClientLibSettingsService } from './shared/services/suvo-users-client-lib-settings/suvo-users-client-lib-settings.service';
import { UsersDialogService } from './shared/services/users-dialog/users-dialog.service';
import { UsersSnackbarService } from './shared/services/users-snackbar/users-snackbar.service';

@NgModule({
  imports: [
    AngularFireAuthModule,
    AuthenticationModule,
    SuvoCoreClientLibModule,
    OrganisationInvitationModule,
    OrganisationModule,
    SubscriptionModule,
    MyAccountModule,
    VerifyModule,
  ],
  exports: [
    AuthenticationModule,
    AngularFireAuthModule,
    AngularFireModule,
    OrganisationInvitationModule,
    MyAccountModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SelectedTenantInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnverifiedEmailInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SelectedOrganisationInterceptor,
      multi: true,
    },
    IdentityService,
    UsersSnackbarService,
    UsersDialogService,
    OrganisationService,
    BranchService,
    CommonOrganisationService,
  ],
})
export class SuvoUsersClientLibModule {
  static forRoot(config: any): ModuleWithProviders<SuvoUsersClientLibModule> {
    console.log('CONFIG', config);
    const suvoUsersClientLibSettings = new SuvoUsersClientLibSettingsService(config);
    return {
      ngModule: SuvoUsersClientLibModule,
      providers: [
        {
          provide: SuvoUsersClientLibSettingsService,
          useValue: suvoUsersClientLibSettings.config,
        },
      ],
    };
  }
}
